import { createOperatorCallAction } from './createOperatorCallAction';
import { fetchCallLog } from './fetchCallLog';
import { fetchCallLogs } from './fetchCallLogs';
import { fetchCallRecordingUrl } from './fetchCallRecordingUrl';
import { fetchCustomerLiveCallLog } from './fetchCustomerLiveCallLog';
import { fetchLastCallLog } from './fetchLastCallLog';
import { fetchLiveCallLog } from './fetchLiveCallLog';
import { fetchLiveOutboundCalls } from './fetchLiveOutboundCalls';
import { fetchSupervisorPendingCalls } from './fetchSupervisorPendingCalls';
import { fetchTotalCallsFromPartnerUsers } from './fetchTotalCallsFromPartnerUsers';
import { generateCallSummaryScoring } from './generateCallSummaryScoring';
import { getCallSummariesByCallLogId } from './getCallSummariesByCallLogId';
import { getConferenceFriendlyName } from './getConferenceFriendlyName';
import { markAsEndCallLog } from './markAsEndCallLog';
import { saveRegistrationCallOutcome } from './saveRegistrationCallOutcome';
import { sendNoClientAudioCallAndSms } from './sendNoClientAudioCallAndSms';
import { transcribeCallLog } from './transcribeCallLog';
import { updateCallLog } from './updateCallLog';
import { updateLiveCallCallType } from './updateLiveCallCallType';
import { fetchMissedCalls } from './missedCalls';

export const callLogService = {
  createOperatorCallAction,
  fetchMissedCalls,
  fetchCallLog,
  fetchCallLogs,
  fetchCallRecordingUrl,
  fetchCustomerLiveCallLog,
  fetchLastCallLog,
  fetchLiveCallLog,
  fetchLiveOutboundCalls,
  fetchSupervisorPendingCalls,
  fetchTotalCallsFromPartnerUsers,
  generateCallSummaryScoring,
  getCallSummariesByCallLogId,
  getConferenceFriendlyName,
  markAsEndCallLog,
  saveRegistrationCallOutcome,
  sendNoClientAudioCallAndSms,
  transcribeCallLog,
  updateCallLog,
  updateLiveCallCallType,
};
